<template>
  <div>
    <ul class="select-option">
      <li>
        <span class="select-title">查询日期：</span>
        <el-date-picker
          v-model="searchDate"
          type="date"
          placeholder="报表日期"
          value-format="yyyy-MM-dd"
        />
      </li>
      <li>
        <el-button
          v-if="checkPermission('导出报表:导出案件库存状态', permList)"
          type="primary"
          icon="iconfont icon-daochu"
          @click="exportExcel"
        >
          导出案件库存状态
        </el-button>
      </li>
    </ul>
    <ul class="select-option">
      <li>
        <el-button
          v-if="checkPermission('导出报表:导出调查费报表', permList)"
          type="primary"
          icon="iconfont icon-daochu"
          @click="tradeInfoExcel"
        >
          导出调查费报表
        </el-button>
      </li>
    </ul>

    <ul class="select-option" style="clear: both;">
      <li>
        <span class="select-title">查询日期：</span>
        <el-date-picker
          v-model="reportStartDate"
          type="date"
          placeholder="开始日期"
          value-format="yyyy-MM-dd"
          style="margin-right: 10px;"
        />
        <el-date-picker
          v-model="reportEndDate"
          type="date"
          placeholder="结束日期"
          value-format="yyyy-MM-dd"
        />
      </li>
      <li>
        <el-button
          v-if="checkPermission('导出报表:导出案件基础信息', permList)"
          v-loading.fullscreen.lock="fullscreenLoading"
          type="primary"
          icon="iconfont icon-daochu"
          element-loading-text="基础信息报表需要的时间较长，请勿关闭或刷新当前浏览器，请耐心等待下载完成！在等待下载期间你可以改用其他浏览器继续登录风控进行工作！"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.8)"
          @click="exportCaseDetailExcel(1)"
        >
          导出案件基础信息
        </el-button>
      </li>
    </ul>
    <ul class="select-option" style="clear: both;">
      <li>
        <el-button
          v-if="checkPermission('导出报表:案例运营报表', permList)"
          type="primary"
          icon="iconfont icon-daochu"
          @click="caseUseOperationExcel"
        >
          案例运营报表
        </el-button>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      searchDate: null, // 查询日期
      // loadTxt: "加载中...",
      fullscreenLoading: false,
      reportStartDate: null, // 报案开始日期
      reportEndDate: null, // 报案结束日期
    };
  },

  computed: {
    ...mapState({
      permList: (state) => state.permission.permList,
    }),
  },

  methods: {
    /**
     * 导出案件库存状态
     */
    async exportExcel() {
      const vm = this;
      const { searchDate } = vm;
      const homePath = vm.homePath();
      const reportDate = searchDate == null ? "" : searchDate;

      try {
        const { data: result } = await vm.axios.get(
          `${homePath}/report/checkStockReports?reportDate=${reportDate}&_t=${new Date().valueOf()}`
        );
        if (result && result.status === "000000") {
          const url = `${homePath}/report/stockReports?reportDate=${reportDate}&_t=${new Date().valueOf()}`;
          window.location.href = url;
        } else {
          vm.$alert(result && result.message);
        }
      } catch (error) {
        console.log("疑点记录-增加-请求失败", error);
      }
    },

    /**
     * 导出案件基础信息
     * @param {number} exportType   报表类型 1：基础信息表
     */
    async exportCaseDetailExcel(exportType = 1) {
      const vm = this;
      const homePath = vm.homePath();
      const { reportStartDate, reportEndDate } = vm;
      const date = new Date();
      // 当前日期
      const currdate =
        date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
      const startTime = reportStartDate == null ? null : reportStartDate;
      const endTime = reportEndDate == null ? currdate : reportEndDate;
      try {
        const { data: result } = await vm.axios.post(
          `${homePath}/export-task/add`,
          {
            exportType,
            startTime,
            endTime,
          }
        );

        if (result && result.status === "000000") {
          vm.fullscreenLoading = true;
          vm.checkExportTask(result.data);
        } else {
          vm.$alert(result && result.message);
        }
      } catch (error) {
        console.log("增加报表导出任务-请求失败", error);
      }
    },

    /**
     * 查询导出任务状态
     * @param {number} exportTaskId   导出任务id
     */
    async checkExportTask(exportTaskId = "") {
      const vm = this;
      const homePath = vm.homePath();

      try {
        const { data: result } = await vm.axios.get(
          `${homePath}/export-task/check/${exportTaskId}`
        );
        const newData = result && result.data;

        if (newData && Number(newData.exportStatus) === 0) {
          // 进行中
          setTimeout(() => {
            vm.checkExportTask(newData.exportTaskId);
          }, 5000);
        } else if (newData && Number(newData.exportStatus) === 1) {
          // 成功
          vm.fullscreenLoading = false;
          // 打开新页面
          window.location.href = newData.exportUrl;
        } else {
          vm.fullscreenLoading = false;
          // 失败
          vm.$alert(result && result.message);
        }
      } catch (error) {
        console.log("查询导出任务状态-请求失败", error);
      }
    },

    /**
     * 导出调查费报表
     */
    tradeInfoExcel() {
      const vm = this;
      const { searchDate } = vm;
      const homePath = vm.homePath();
      const reportDate = searchDate == null ? "" : searchDate;

      const url = `${homePath}/report/tradeInfoExport?reportDate=${reportDate}&_t=${new Date().valueOf()}`;
      window.location.href = url;
    },

    /**
     * 案例运营报表
     */
    caseUseOperationExcel() {
      const vm = this;
      const homePath = vm.homePath();

      const url = `${homePath}/report/case-use-operation?_t=${new Date().valueOf()}`;
      window.location.href = url;
    },
  },
};
</script>

<style>
.select-option li {
  float: left;
  margin: 10px;
}
</style>
